import React from 'react';
import Projects from '../components/Projects';
import { portfolioData } from '../mock';

const ProjectsPage = () => {
  return (
    <div className="pt-20">
      <Projects data={portfolioData} />
    </div>
  );
};

export default ProjectsPage;